;(function() {
  'use strict'

  Controller.$inject = ["Channel", "featureService"];
  angular.module('app.core').component('channelForwardTags', {
    controller: Controller,
    templateUrl: 'channel-forward-tags.html',
    bindings: {
      channel: '<',
      survey: '<',
    },
  })

  // the "All tags" row's value; tag names are strings, so it never matches one
  var ALL_TAGS = true

  /* @ngInject */
  function Controller(Channel, featureService) {
    var ctrl = this
    var Role = Channel.ForwardTagsRole
    var picks

    ctrl.$onInit = onInit
    ctrl.toggle = toggle
    ctrl.selectRole = selectRole
    ctrl.onTagsChange = onTagsChange
    ctrl.formatTags = formatTags

    ctrl.Role = Role
    ctrl.roleOptions = [
      {
        value: Role.SEND,
        label: 'First survey',
        hint:
          'Forwards the tags selected below. Receives nothing: a &' +
          Channel.FORWARD_TAGS_PARAM +
          "=… added to this channel's link is ignored.",
      },
      {
        value: Role.RECEIVE_AND_SEND,
        label: 'Middle survey',
        hint:
          "Receives the tags on this channel's link and forwards them with the tags selected below.",
      },
      {
        value: Role.RECEIVE,
        label: 'Last survey',
        hint: "Receives the tags on this channel's link. Forwards nothing.",
      },
    ]

    function onInit() {
      var forwardTags = ctrl.channel.forwardTags
      ctrl.canUseChannelRedirects = featureService.canUseChannelRedirects()
      ctrl.tags = ctrl.survey.getTags()
      ctrl.tagOptions = [
        { value: ALL_TAGS, label: 'All tags', promoted: true },
      ].concat(
        _.map(ctrl.tags, function(tag) {
          return { value: tag, label: tag }
        })
      )
      ctrl.selectedTags = selection(forwardTags)

      // each forwarding role keeps its own selection while the editor is open
      picks = {}
      picks[Role.SEND] = { allTags: true, tags: [] }
      picks[Role.RECEIVE_AND_SEND] = { allTags: false, tags: [] }
    }

    function selection(forwardTags) {
      return forwardTags.allTags
        ? [ALL_TAGS]
        : _.intersection(ctrl.tags, forwardTags.tags)
    }

    function toggle() {
      var off = ctrl.channel.forwardTags.role === Role.OFF
      selectRole(off ? Role.SEND : Role.OFF)
    }

    // Off and Last have no picker, so they leave the values as they are
    function selectRole(role) {
      var forwardTags = ctrl.channel.forwardTags
      if (picks[forwardTags.role]) {
        picks[forwardTags.role] = _.pick(forwardTags, ['allTags', 'tags'])
      }
      forwardTags.role = role
      if (!picks[role]) return
      forwardTags.allTags = picks[role].allTags
      forwardTags.tags = picks[role].tags
      ctrl.selectedTags = selection(forwardTags)
    }

    // ticking "All tags" unticks every other row; ticking every row ticks "All tags"
    function onTagsChange(selected) {
      var tags = _.without(selected, ALL_TAGS)
      var allTags =
        _.last(selected) === ALL_TAGS || tags.length === ctrl.tags.length
      ctrl.selectedTags = allTags ? [ALL_TAGS] : tags
      ctrl.channel.forwardTags.allTags = allTags
      ctrl.channel.forwardTags.tags = allTags ? [] : tags
    }

    function formatTags(options) {
      if (_.some(options, { value: ALL_TAGS })) return 'All tags'
      if (!options.length) return 'None'
      return options.length + ' of ' + ctrl.tags.length
    }
  }
})()
